const JOB_TITLE_AMBIGUOUS_ACRONYMS = new Set([
	'FIR',
	'PET',
	'CAP',
	'ARC',
	'SALT',
	'ALP',
	'PRE',
	'IT',
	'ST',
	'MS',
	'DO',
	'US',
	'NO',
	'NOT',
	'CONS',
	'HOD'
]);

export const JOB_TITLE_UNAMBIGUOUS_ACRONYMS = new Set([
	// Executive / business
	'CEO',
	'CFO',
	'COO',
	'CMO',
	'CNO',
	'VP',
	'SVP',
	'VD',

	// Medical degrees & general roles
	'MD',
	'PHD',
	'DPHIL',
	'RN',
	'GP',
	'PA',
	'NP',
	'ANP',
	'ENP',
	'CNM',
	'CNS',
	'CPN',
	'ACP',
	'SPR',
	'SHO',
	'IMT',
	'FMH',

	// Specialties / clinical departments
	'ENT',
	'IR',
	'ICS',
	'USG',
	'POCT',
	'NIHR',
	'IBD',
	'IVF',
	'CT',
	'MRI',
	'GDP',
	'BMA',

	// Nursing / allied health / technical assistants (multi-language)
	'HCA',
	'RGN',
	'HCSW',
	'IDE',
	'IADE',
	'SLT',
	'PTA',
	'ZFA',
	'ZMP',
	'ZMF',
	'ZMFA',
	'ZMV',
	'MTA',
	'MTAF',
	'MFA',
	'TSRM',
	'BTA',
	'BMTA',

	// Country/region-specific recurring role codes
	'EIR',
	'PKA',
	'POH',
	'GGZ',
	'KBU',
	'MPA',
	'MIR',
	'POZ',
	'MTRA',
	'PIR',
	'RFIR',
	'QIR',
	'AIOS',
	'BAIOS',
	'HAIO',
	'BIR',
	'UCI',
	'UCIP',
	'ICUS',
	'LIS',
	'LKA',
	'DGKP',
	'ZOZ',
	'SUAP',
	'OA',
	'FEA',
	'FFI',
	'SSA',
	'MBF',
	'CCA',
	'MTR',
	'GPN',
	'GPA',
	'GPST',
	'SEH',
	'SCN',
	'UME',
	'MDL',
	'UDM',
	'AFYC',
	'IBODE',
	'HDJ',

	// Additional medical/clinical acronyms
	'RFA',
	'CTA',
	'ACCP',
	'CVRM',
	'FEBO',
	'OPAT',
	'NICU',
	'ECMO',
	'COPD',
	'SDEC',
	'FAMH',
	'NHS',
	'HIV',
	'EKG',
	'EEG',
	'MRT',
	'RDN',
	'CMA',
	'CRC',
	'HNO',

	// Additional executive/business acronyms
	'CIO',
	'CSO',
	'CCO',
	'AVP',
	'AOA',
	'DEI',

	// Level/seniority suffixes (Roman numerals, e.g. "Physician II")
	'II',
	'III',

	// Short codes with no recognizable dictionary meaning in any language
	// seen in the data, but which recur as distinct all-caps tokens rather
	// than one-off typos — treated as unidentified acronyms/role codes.
	'DD',
	'LP',
	'FF',
	'KEF',
	'ASO',
	'PFF',
	'ETP',
	'PLS',
	'QMB',
	'BMS',
	'LAK',
	'SAF',
	'TRM',
	'SOH',
	'JIP',
	'DMS',
	'DSN',
	'PFA',
	'PDI',
	'AMU',
	'LTA',
	'EIF',
	'TLSB',
	'BPDO',
	'IPPP',
	'PHPT',
	'EJER',
	'IDEC',
	'ALPI',
	'IPOG',
	'CPSI',
	'UDENFOBG',
	'PRATTACH',

	// Found via prod data diff against the above list
	'MTLA',
	'DR',
	'HR',
	'QA',
	'EM',
	'GI',
	'TB',
	'IM',
	'CF',
	'RA',
	'CP',
	'HF',
	'RD',
	'SN',
	'ORL',
	'EMG',
	'PRP',
	'CTO',
	'PDG',
	'CDE',
	'NCHD',
	'GPSI',
	'VMO',
	'CANP',
	'BRCA',
	'ARRS',
	'QP',
	'PCN',
	'FA',
	'OG',
	'ZA',
	'CNC',
	'CSE',
	'HAB',
	'JCF',
	'SAS',
	'NUM',
	'DIR',
	'WBA',
	'PGI',
	'INP',
	'ZZP',
	'NFSG',
	'SHCA',
	'DS',
	'TS',
	'DA',

	// Found via residual-coverage analysis (words still driving uncovered rows)
	'PH',
	'CRM',
	'ECT',
	'CRA',
	'TPN',
	'RCN',
	'RT',
	'SAPV',
	'UOC',
	'USZ',
	'MLA',
	'ASSIR',

	// Found via combined dev/prod residual reconciliation
	'GYN',
	'APRN',
	'APNP',
	'CAMHS',
	'CCHT',
	'CBT',
	'DEPT',
	'KOL',
	'DGKS',
	'ICB',
	'OCT',
	'OPD',
	'DM',
	'PM'
]);

export const JOB_TITLE_ACRONYMS = new Set([
	...JOB_TITLE_UNAMBIGUOUS_ACRONYMS,
	...JOB_TITLE_AMBIGUOUS_ACRONYMS
]);

// Connector/article words (across the languages seen in the raw data) that
// should stay lowercase mid-title rather than being capitalized, e.g.
// "Director of Nursing" not "Director Of Nursing".
export const JOB_TITLE_MINOR_WORDS = new Set([
	'of',
	'and',
	'in',
	'the',
	'for',
	'en',
	'y',
	'de',
	'del',
	'des',
	'der',
	'und',
	'di',
	'la',
	'e',
	'a',
	'es',
	'por',
	'delle',
	'zur',
	'i',
	'et',
	'with',
	'to',
	'con'
]);
